module.exports = __webpack_public_path__ + "img/08ycrz.e5250092.svg";